/**
 * Pure helpers for resolving a tour's effective settings and schedule window.
 * Kept free of DOM/driver so they are trivially unit-testable.
 */

import { TOUR_DEFAULTS, type TourEnvSettings } from '../config';

export type ResolvedSettings = Required<TourEnvSettings>;

/** Fill any unset fields from the safe-off defaults. */
export function resolveSettings(entry: TourEnvSettings | undefined): ResolvedSettings {
  return { ...TOUR_DEFAULTS, ...(entry || {}) };
}

/** Whether `now` falls within the optional [startDate, endDate] window (inclusive days). */
export function withinSchedule(settings: Pick<ResolvedSettings, 'startDate' | 'endDate'>, now: Date): boolean {
  if (settings.startDate && now < new Date(`${settings.startDate}T00:00:00`)) return false;
  if (settings.endDate && now > new Date(`${settings.endDate}T23:59:59`)) return false;
  return true;
}
